import { frontendURL } from '../../../helper/URLHelper';

const InternalChatPage = () =>
  import(
    /* webpackChunkName: "internal-chat" */ '../../../components/internalChat/InternalChatPage.vue'
  );

export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal-chat'),
    name: 'internal_chat',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: InternalChatPage,
  },
];
